'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reviewsForClass = exports.classInfoByVenueAlias = exports.scheduleForClass = exports.classesByVenue = undefined;

var _sagaTools = require('@classpass/saga-tools');

var classesByVenue = exports.classesByVenue = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CLASSES_BY_VENUE', function (client, venueId, params, overrides) {
  return client.venues.getClassesByVenue(venueId, params, overrides);
}, { defaultKey: 1 });

var scheduleForClass = exports.scheduleForClass = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SCHEDULE_FOR_CLASS', function (client, classId, options) {
  return client.class.getSchedules(classId, options).then(function (data) {
    return data.schedules;
  });
}, { defaultKey: 1 });

var classInfoByVenueAlias = exports.classInfoByVenueAlias = (0, _sagaTools.makeEntityScaffold)('SAGA.API.CLASS_INFO_BY_VENUE_ALIAS', function (client, alias, classAlias, overrides) {
  return client.venues.getClassInfoByVenueAlias(alias, classAlias, overrides);
}, { defaultKey: 2 });

var reviewsForClass = exports.reviewsForClass = (0, _sagaTools.makeEntityScaffold)('SAGA.API.REVIEWS_FOR_CLASS', function (client, classId) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
  return client.class.getReviews(classId, {
    page_size: perPage,
    page: parseInt(page, 10),
    meta: true
  });
}, { defaultKey: [1, 2] });